function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "26",
  height: "12",
  viewBox: "0 0 26 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.464 0c.762 0 1.393.68 1.393 1.5v9c0 .82-.631 1.5-1.393 1.5-.761 0-1.393-.68-1.393-1.5v-9c0-.82.632-1.5 1.393-1.5zM9.286 1.5c0-.82-.632-1.5-1.393-1.5H1.857C.743 0 0 1 0 2v8c0 1 .743 2 1.857 2H7.43c1.114 0 1.857-1 1.857-2V7.5c0-.82-.632-1.5-1.393-1.5C7.13 6 6.5 6.68 6.5 7.5V9H2.786V3h5.107c.761 0 1.393-.68 1.393-1.5zM26 1.5c0-.82-.631-1.5-1.393-1.5H19.5c-1.021 0-1.857.9-1.857 2v8.5c0 .82.631 1.5 1.393 1.5.761 0 1.393-.68 1.393-1.5V8h2.321c.761 0 1.393-.68 1.393-1.5S23.51 5 22.75 5h-2.321V3h4.178C25.37 3 26 2.32 26 1.5z",
  fill: "#fff"
})));